<footer class="bg-primary text-dark pt-5 pb-4">
  <div class="container-fluid px-3 px-md-4 px-lg-5">

    <!-- TOP FOOTER -->
    <div class="row gy-4">

      <!-- BRAND -->
      <div class="col-12 col-lg-4">
        <div class="d-flex align-items-center gap-3 mb-3">
          <div class="footer-logo">
            {{ footer_data.brand.initial }}
          </div>
          <h6 class="mb-0 text-dark fw-semibold">
            {{ footer_data.brand.name }}
          </h6>
        </div>

        <p class="small mb-3">
          {{ footer_data.brand.description }}
        </p>

        <small class="text-dark">
          {{ footer_data.brand.powered_by }}
        </small>
      </div>

      <!-- PLATFORM -->
      <div class="col-6 col-md-3 col-lg-2">
        <h6 class="text-dark fw-semibold mb-3">
          {{ footer_data.platform.title }}
        </h6>
        <ul class="list-unstyled">
          <li
            v-for="item in footer_data.platform.links"
            :key="item.key"
            class="mb-2"
          >
            <a :href="item.href" class="footer-link">
              {{ item.label }}
            </a>
          </li>
        </ul>
      </div>

      <!-- RESOURCES -->
      <div class="col-6 col-md-3 col-lg-2">
        <h6 class="text-dark fw-semibold mb-3">
          {{ footer_data.resources.title }}
        </h6>
        <ul class="list-unstyled">
          <li
            v-for="item in footer_data.resources.links"
            :key="item.key"
            class="mb-2"
          >
            <a :href="item.href" class="footer-link">
              {{ item.label }}
            </a>
          </li>
        </ul>
      </div>

      <!-- LEGAL -->
      <div class="col-6 col-md-3 col-lg-2">
        <h6 class="text-dark fw-semibold mb-3">
          {{ footer_data.legal.title }}
        </h6>
        <ul class="list-unstyled">
          <li
            v-for="item in footer_data.legal.links"
            :key="item.key"
            class="mb-2"
          >
            <a :href="item.href" class="footer-link">
              {{ item.label }}
            </a>
          </li>
        </ul>
      </div>

    </div>

    <!-- DIVIDER -->
    <hr class="footer-divider my-4" />

    <!-- BOTTOM FOOTER -->
    <div class="d-flex flex-column flex-md-row justify-content-between align-items-center small">
      <span>
        © {{ footer_data.rights.year }} {{ footer_data.rights.company }}.
        {{ footer_data.rights.text }}
      </span>

      <span class="mt-2 mt-md-0">
        {{ footer_data.rights.origin }}
      </span>
    </div>

  </div>
</footer>
